import type { LDContext, ProviderConfig } from 'launchdarkly-react-client-sdk';

import { LD_INIT_TIMEOUT_SECONDS } from './launchdarkly-context.utils';

type LaunchDarklyProviderOptions = NonNullable<ProviderConfig['options']>;
type LaunchDarklyPlugins = NonNullable<LaunchDarklyProviderOptions['plugins']>;

export const DEFAULT_LAUNCHDARKLY_CONTEXT: LDContext = {
  kind: 'user',
  key: 'anonymous-user',
  anonymous: true,
};

export function buildLaunchDarklyProviderConfig(args: {
  clientSideID: string;
  plugins?: LaunchDarklyPlugins;
}): Pick<ProviderConfig, 'clientSideID' | 'context' | 'timeout' | 'options'> {
  const { clientSideID, plugins = [] } = args;

  return {
    clientSideID,
    context: DEFAULT_LAUNCHDARKLY_CONTEXT,
    timeout: LD_INIT_TIMEOUT_SECONDS,
    options: {
      bootstrap: 'localStorage' as const,
      plugins,
    },
  };
}
